import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error (benign, caused by Radix UI components)
// This error is harmless and occurs in many UI libraries
const suppressResizeObserver = (e) => {
  if (e.message?.includes?.('ResizeObserver loop') || 
      e?.includes?.('ResizeObserver loop')) {
    e.stopImmediatePropagation?.();
    return true;
  }
  return false;
};

// Suppress in error event
window.addEventListener('error', (e) => {
  if (suppressResizeObserver(e)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Suppress in unhandled rejection
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes?.('ResizeObserver loop')) {
    e.preventDefault();
    return false;
  }
});

// Override console.error
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.toString?.().includes?.('ResizeObserver loop')) return;
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) return;
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
